module.exports = __webpack_public_path__ + "img/premium-satin_icon.5d9eb164.png";